module.exports = __webpack_public_path__ + "img/home_pic_3.5_4.40adb039.webp";